import React, { useState, useEffect, useMemo, useCallback } from 'react';
import gsap from 'gsap';

import useMediaStore from '../../../common/store/useMediaStore';
import useScrollStore from '../../../common/store/useScrollStore';
import { getSections, getThresholds } from '../../Main/utils';

const useAnimation = (
  logo: React.RefObject<HTMLDivElement>,
  circle: React.RefObject<SVGSVGElement>,
  link: React.RefObject<HTMLDivElement[]>
) => {

  const thresholds = useMemo(() => getThresholds(), []);
  const [section, setSection] = useState(0);

  const rotateLogo = useCallback((position: number) => {
    const duration = 0.5;
    const ease = "power2.out";

    gsap.to(circle.current, {
      duration,
      ease,
      rotate: -position / 10
    });
  }, [circle]);

  const animateSideNav = useCallback((doms: HTMLDivElement[], type: "display" | "hide") => {
    const duration = 0.25;
    const ease = "power2.out";
    const stagger = 0.05;

    gsap.to(doms, {
      duration,
      ease,
      stagger,
      opacity: type === "display" ? 1 : 0
    });
  }, []);

  useEffect(() => useScrollStore.subscribe(state => {
    if (useMediaStore.getState().md) {
      rotateLogo(state.position);

      const _section = getSections(-state.position + 10, thresholds);
      setSection(_section);

      const doms = [logo.current, [...link.current!]] as HTMLDivElement[];

      if (section === 0 && _section === 1) animateSideNav(doms, "display");
      else if (_section === 0) animateSideNav(doms, "hide");
      else animateSideNav(doms, "display");
    }
  }), [animateSideNav, link, logo, section, thresholds]);

  return section;
}

export default useAnimation;